import { render } from "./GroupRollCall.vue?vue&type=template&id=183c0a14&scoped=true"
import script from "./GroupRollCall.vue?vue&type=script&lang=js"
export * from "./GroupRollCall.vue?vue&type=script&lang=js"

import "./GroupRollCall.vue?vue&type=style&index=0&id=183c0a14&scoped=true&lang=css"

import exportComponent from "/Users/vncsalencar/Personal/Projects/araruna-anare-rollcall/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183c0a14"]])

export default __exports__